/**
 * The status of a dispute, in words a person in trouble can read.
 *
 * "Open" is a database state. "Logged" is a promise that somebody has it. The difference matters most
 * to the person who is least able to interpret the first one.
 *
 * (In its own file because a Next.js page module may export only a default — and because a component
 * that lives in a route file is a component waiting to be duplicated.)
 */

import type { Dispute } from '@/lib/api';

export function StatusBadge({ status }: { status: Dispute['status'] }) {
  const tone: Record<Dispute['status'], string> = {
    open: 'border-warning/30 bg-warning/10 text-warning',
    investigating: 'border-info/30 bg-info/10 text-info',
    awaiting_participant: 'border-warning/30 bg-warning/10 text-warning',
    resolved: 'border-accent/30 bg-accent/10 text-accent',
    withdrawn: 'border-border bg-canvas text-ink-muted',
  };

  const label: Record<Dispute['status'], string> = {
    open: 'Logged',
    investigating: 'We are looking',
    awaiting_participant: 'We need something from you',
    resolved: 'Resolved',
    withdrawn: 'Withdrawn',
  };

  return (
    <span
      className={`shrink-0 rounded-full border px-2.5 py-0.5 text-xs font-medium ${tone[status]}`}
    >
      {label[status]}
    </span>
  );
}
